import { type ChatSseEvent } from '@aura/shared';

/**
 * Separa en eventos el texto SSE que llega por partes (`event: x\ndata: {...}\n\n`). Un evento
 * puede quedar cortado entre dos partes: lo incompleto se guarda hasta la próxima.
 */
export class SseParser {
  private buffer = '';

  push(text: string): ChatSseEvent[] {
    this.buffer += text.replace(/\r\n/g, '\n');
    const events: ChatSseEvent[] = [];
    let end: number;
    while ((end = this.buffer.indexOf('\n\n')) !== -1) {
      const block = this.buffer.slice(0, end);
      this.buffer = this.buffer.slice(end + 2);
      let event = '';
      const data: string[] = [];
      for (const line of block.split('\n')) {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).trimStart());
      }
      if (!event || data.length === 0) continue;
      try {
        events.push({ event, data: JSON.parse(data.join('\n')) } as ChatSseEvent);
      } catch {
        // Un evento roto no corta el resto de la respuesta.
      }
    }
    return events;
  }
}
